module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-03-a9c44d362bc2ed15869ea7561de58a26.jpg";